import clsx from "clsx";
import type { ReactNode } from "react";

/** A keyboard cap, for the keyboard-first practice loop (spec §5). */
export function Kbd({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <kbd
      className={clsx(
        "inline-flex min-w-[1.5rem] items-center justify-center rounded border border-ink-300 bg-ink-100 px-1.5 py-0.5",
        "font-mono text-[0.7rem] font-medium text-ink-700 shadow-sm",
        "dark:border-ink-700 dark:bg-ink-800 dark:text-ink-200",
        // A touch screen has no keys to press: the hint is noise there (P0-10).
        "[@media(pointer:coarse)]:hidden",
        className,
      )}
    >
      {children}
    </kbd>
  );
}
